import styled from 'styled-components';

import { colors } from 'styles/colors';

const textMain = colors.text['main-900'];
const textSub = colors.text['sub-500'];

export const HistoryCardWrap = styled.div`
  margin-top: 32px;
`;

export const HistoryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const HistoryTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${textMain};
`;

export const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  border-radius: 4px;
  padding: 5px 8px;
  font-size: 12px;
  font-weight: 500;
  color: ${textSub};
  cursor: pointer;
  transition: background 200ms cubic-bezier(.2,0,0,1);

  &:hover:not(:disabled) {
    background: ${colors.bg['weak-100']};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  font-size: 13px;
  color: ${colors.Grey300};
  text-align: center;
  padding: 32px 0;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const DataTable = styled.table`
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
`;

export const PaginationWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const Th = styled.th`
  font-size: 12px;
  font-weight: 600;
  color: ${textSub};
  text-align: left;
  padding: 8px 16px 8px 0;
  border-bottom: 1px solid ${colors.Grey050};
`;

export const Td = styled.td`
  font-size: 13px;
  color: ${textMain};
  padding: 12px 16px 12px 0;
  border-bottom: 1px solid ${colors.Grey050};
  vertical-align: middle;
`;

export const TdNumber = styled.td`
  font-size: 13px;
  color: ${colors.Grey300};
  font-weight: 600;
  padding: 12px 16px 12px 0;
  border-bottom: 1px solid ${colors.Grey050};
  vertical-align: middle;
  width: 40px;
`;

export const TdNote = styled.div`
  font-size: 12px;
  color: ${colors.Grey300};
  margin-top: 2px;
`;

export const HistoryItemNote = styled.div`
  font-size: 11px;
  color: ${textSub};
  line-height: 1.5;
  margin-top: 3px;
  max-width: 420px;
`;

export const HistoryDeadline = styled.div`
  font-size: 11px;
  color: ${colors.LightBlue};
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 3px;
`;
